import axios from "axios";

class ApiClient {
  constructor(baseURL, defaultHeaders = {}) {
    this.client = axios.create({
      baseURL,
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders,
      },
      timeout: 10000,
    });
     // Automatically set auth token if it exists
     const token = localStorage.getItem("token");
     if (token) {
       this.setAuthToken(token);
     }
     this.client.interceptors.response.use(
       (response) => response,
       (error) => {
         // If subclass or instance has a handleError, call it
         if (this.handleError) {
           return this.handleError(error);
         }
         return Promise.reject(error);
       }
     );
  }

  setAuthToken(token) {
    this.client.defaults.headers["Authorization"] = `Bearer ${token}`;
  }

  get(endpoint, params = {}) {
    return this.client.get(endpoint, { params });
  }

  async post(url, data) {
    try {
      const response = await this.client.post(url, data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  put(endpoint, data = {}, config = {}) {
    return this.client.put(endpoint, data, config);
  }

  delete(endpoint, config = {}) {
    return this.client.delete(endpoint, config);
  }
  handleError(error) {
    console.log("In handleError",error.response.data)
    if (error.response) {
      // Server responded with a status other than 2xx
      throw new Error(error.response.data.message || "Unknown error occurred");
    } else if (error.request) {
      // No response from server
      throw new Error("Server did not respond. Please try again later.");
    } else {
      // Other errors
      throw new Error(error.message);
    }
  }
}

export default ApiClient;
